import React, { Component } from 'react';
import { isEmptyString, isString } from '../../core/util/string';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './InputPlaceholder.css' or its... Remove this comment to see the full error message
import s from './InputPlaceholder.css';
import withStyles from '../../core/isomorphic-style-loader/withStyles';
import { isEmpty } from '../../core/util/empty';

const getPlaceholderState = (field: any) => {
  if (field.active) return s.placeholderTextSmall;

  if (field.value instanceof Object) {
    return Object.values(field.value).every(isEmpty)
      ? s.placeholderTextBig
      : s.placeholderTextSmall;
  }

  return !isEmpty(field.value) ||
    (!field.touched && isString(field.initialValue) && !isEmptyString(field.initialValue))
    ? s.placeholderTextSmall
    : s.placeholderTextBig;
};

type OwnInputPlaceholderProps = {
  focusId: string;
  field: any;
  placeholder?: string;
  containerName?: string;
  asLabel?: boolean;
};

type InputPlaceholderProps = OwnInputPlaceholderProps & typeof InputPlaceholder.defaultProps;

class InputPlaceholder extends Component<InputPlaceholderProps> {
  static defaultProps = { containerName: s.root };

  shouldComponentUpdate(nextProps: InputPlaceholderProps) {
    return (
      getPlaceholderState(nextProps.field) !== getPlaceholderState(this.props.field) ||
      nextProps.placeholder !== this.props.placeholder
    );
  }

  render() {
    const { containerName, focusId, placeholder, field } = this.props;
    const handleOnClick = () => document.getElementById(focusId)?.focus();

    return this.props.asLabel ? (
      <label
        className={`${containerName} placeholderAsLabel`}
        htmlFor={this.props.focusId}
        onClick={handleOnClick}
      >
        <div className={getPlaceholderState(field)}>{placeholder}</div>
      </label>
    ) : (
      <div className={containerName} onClick={handleOnClick}>
        <div className={getPlaceholderState(field)}>{placeholder}</div>
      </div>
    );
  }
}

export default withStyles(s)(InputPlaceholder);
